import React, { useEffect, useState } from 'react'
import style from "./CompanyProfile.module.css";
import templateStyles from "../DashBoard/Templates/Templates.module.css"
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper';
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator';
import ShimmerLoader from '../../components/ShimmerLoader';
import API from "../../ApiConfig";
import { CSV_LOGS_BY_ISSUER, GET_S3_SIGNED_URL, LAST_PUBLISHED_RECORD_BY_ISSUER } from '../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
import { convertDateFormat, setDate } from '../../Utils/helper';
import Pagination from './ExternalDash/Pagination';
import Loader from '../../components/Loader';
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom';
import Icon from 'react-icons-kit';
import { androidOpen } from 'react-icons-kit/ionicons/androidOpen'
import AnimatedLoader from '../../components/AnimationLoader';

const IssuedDataDetails = () => {
    const [loading, setLoading]=useState(false)
  const [currentPage, setCurrentPage]=useState(1)

  const [totalPages, setTotalPages]=useState(1)

  const [currentRecords, setCurrentRecords]=useState([])
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
    const location=useLocation()
    const {id}=useParams()
    
  const getCSVlogs=()=>{
    setLoading(true)
    const params = {
      page: currentPage,
      issuer_company_id:id
    };
    if (dateRange?.startDate && dateRange?.endDate) {
      params.start_date = convertDateFormat(dateRange.startDate);
      params.end_date = dateRange.endDate
        ? convertDateFormat(dateRange.endDate)
        : convertDateFormat(dateRange.startDate);
    }
    API.get(CSV_LOGS_BY_ISSUER,{params})
    .then(res=>{
      setLoading(false)
      setCurrentRecords(res.data.data.result)
      setTotalPages(res.data.data.total_pages)
      
    })
    .catch(err=>{
      setLoading(false)
      cogoToast.error(err.response.data.message)
    })
  }
  const handleDateChange = (field, e) => {
    setDateRange((prev) => ({ ...prev, [field]: e }));
  }
  useEffect(()=>{
    const debounce=setTimeout(()=>{
      getCSVlogs()
    },300)
    return ()=> clearInterval(debounce)
  },[currentPage, dateRange.endDate, dateRange.startDate])
  useEffect(()=>{
    setCurrentPage(1)
  },[])


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  }
  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year:"numeric"
    });
  }
  const handleDownloadFile=(s3_path)=>{
    setLoading(true)
    const params=new FormData()
    params.append("s3_path", s3_path)
    API.post(GET_S3_SIGNED_URL, params)
    .then(res=>{
      setLoading(false)
      if(res.data.status==200){
        const signedUrl=res.data.data.signed_url
        const link=document.createElement('a')
        link.href=signedUrl
        link.setAttribute("download","")
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)
      }
    })
    .catch(err=>{
      setLoading(false)
      cogoToast.error(err.response.data.message)
    })

  }
  return (
    <SlideUpWrapper direction='slide-left'>
             <div
            className={[style.companyProfile, templateStyles.templateHeader].join(
              " "
            )}
          >
            <AnimatedLoader loadingText={"Please Wait.."}  isOpen={loading}/>
            <IssuerNavigator
              title={location.state?.company_name || "Company Details"}
              actions={() => <></>}
              step={"/reports"}
            />
          </div>

          <div style={{ margin: "1rem", height:"100vh" }}>                    
                    <div className={style.searchContainer}>


                              <div className="exportRecords">
            <input
              type="date"
              className={style.datePicker}
              value={dateRange.startDate}
              style={{ margin: "10px 25px 0px 25px" }}
              onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
            />
            <input
              type="date"
              className={style.datePicker}
              value={dateRange.endDate}
              style={{margin:"10px 25px 0px 25px"}}
              onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
            />

            </div>
                    </div>

                    <div style={{marginTop:"1rem"}}>
                      <div className="credentials-table">
                              <table style={{ borderRadius: "10px" }}>
                                <tr className="credentials-header bg-lgray">
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">File Name</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Total Records</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Uploaded File</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Success Count</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Error Count</div>
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Error File</div>
                                  </th>
                      
                      
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Created At</div>
                      
                                  </th>
                                  <th className="credentials-th">
                                    <div className="credentials-table-text">Updated At</div>
                      
                                  </th>
                                </tr>
                                {loading ? (
                                  <>
                                    <tr className="credentials-tr">
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                      <td className="credentials-td">
                                        <div className="credentials-table-text">
                                          {" "}
                                          <ShimmerLoader width="7rem" height="1.5rem" />
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                ) : currentRecords &&currentRecords.length === 0 ? (
                                  <tr className="credentials-tr">
                                    <td colSpan="6" className="credentials-td text-center">
                                      <div className="Data_List">No Records</div>
                                    </td>
                                  </tr>
                                ) : (
                                  <>
                                    {currentRecords&& currentRecords.map((i, index) => {
                                      return (
                                        <tr
                                          className="credentials-tr"
                                          style={{ animationDelay: `${index * 0.1}s` }}
                                        >
                                          <td className="credentials-td" style={{justifyContent:"start"}}>
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center" ,width:"7rem",wordBreak:"break-all",overflowWrap: "break-word" }}
                                            >
                                              <div>{i.file_name}</div>
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center" }}
                                            >
                                              <div>{i.total_records}</div>
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center", color:"#1c64f2", cursor:"pointer" }}
                                              onClick={()=>handleDownloadFile(i.uploaded_file_path)}
                                              
                                            >
                                            {i.uploaded_file_path ?  <div>Uploaded File</div>:""}
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div
                                              className="credentials-table-text1"
                                              style={{ display: "flex", alignItems: "center" }}
                                            >
                                              <div>{i.success_count}</div>
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div className="credentials-table-text1" style={{textAlign:"center"}}>
                                              {i.error_count}
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div className="credentials-table-text1" style={{color:"#1c64f2", cursor:"pointer"}} onClick={()=>handleDownloadFile(i.error_file_path)}>
                                             {i.error_file_path ? "Error file":null}
                                            </div>
                                          </td>
                                          <td className="credentials-td">
                                            <div className="credentials-table-text1" style={{textAlign:"center"}}>
                                              {formatDate(i.created_at)}
                                            </div>
                                          </td>
                                          <td className="credentials-td Action-row">
                                          <div className="eye-icon" >
                                          <div className="credentials-table-text1">
                                             {formatDate( i.updated_at)}
                                            </div>
                                                                </div>
                                          </td>
                                              </tr>
                                              );
                                            })}
                                            </>
          )}
        </table>
                    </div>
                    </div>
                    <div style={{ margin: "10px" }}>
          <Pagination
            nPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>
                    </div>
        </SlideUpWrapper>
  )
}


export default IssuedDataDetails